<template>
    <v-row class="ml-2" style="max-width: 580px">
      <v-col cols="10" class="mb-n5">
        <div class="font-weight-bold">Description</div>
        <v-textarea outlined :disabled="!editable" v-model="descriptionValue" ref="description"></v-textarea>
      </v-col>
      <v-col cols="2">
        <v-btn class="mt-4" v-if="!editable" icon @click="enableEditDescription">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-col>
      <v-btn :disabled="!editable" v-if="!descriptionIsSet" @click="setDescription" color="primary">Save</v-btn>
      <v-btn :disabled="!editable" v-if="descriptionIsSet" @click="updateDescription" color="primary">update</v-btn>
    </v-row>
</template>

<script>
const Iam = require('iam')
export default {
  disabled: false,
  data() {
    return {
      description: "",
      descriptionValue: "",
      editable: false,
    }
  },
  computed: {
    globalId() {
      return this.$route.params.organization
    },
    descriptionIsSet() {
      return this.description != ""
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$api.getDescription("en", this.globalId, this.callBack(response=> {
        this.description = response.text
        this.descriptionValue = response.text
      }))
    },
    enableEditDescription() {
      this.editable = true
      setTimeout(() => {
        this.$refs.description.focus()
      }, 10)
    },
    setDescription() {
      const body = new Iam.LocalizedInfoText()
      body.langkey = "en"
      body.text = this.descriptionValue
      this.$api.setDescription(body, this.globalId, this.callBack())
      this.editable = false
    },
    updateDescription() {
      const body = new Iam.LocalizedInfoText()
      body.langkey = "en"
      body.text = this.descriptionValue
      this.$api.updateDescription(body, this.globalId, this.callBack())
      this.editable = false
    }
  }
}
</script>